import styled from 'styled-components';

import { ICardProps } from '@/components/Page';
import { flex } from '@/styles/minix';

export const MemberWrap = styled.div<ICardProps>`
	${flex('row', 'flex-start')};
	flex-wrap: wrap;
	.member-wrap {
		width: ${({ cardWidth }) => `${cardWidth}px`};
		height: ${({ cardHeight }) => `${cardHeight}px`};
		margin-left: ${({ cardLeft }) => `${cardLeft}px`};
		margin-top: ${({ cardTop }) => `${cardTop}px`};
		cursor: pointer;
		border: 1px solid #ebecf0;
		border-radius: 4px;
		:hover {
			border: 1px solid #ebecf0;
			box-shadow: 0px 4px 6px 4px rgb(23 43 77 / 21%);
			border-radius: 4px;
		}
		.member-bg-img {
			width: 99%;
			height: 168px;
			border-radius: 4px;
			object-fit: cover;
		}
	}
`;

export const MemberContentTitleWrap = styled.div`
	${flex('row', 'space-between', 'center')};

	> .left,
	> .right {
		${flex('row', 'flex-start', 'center')};
	}

	> .left {
		> .title {
			font-size: 16px;
			color: #a9adba;
			cursor: pointer;
			:hover {
				text-decoration: underline;
			}
			:last-child {
				margin-left: 15px;
			}
		}

		> .active-title {
			color: #344563;
		}
	}

	> .right {
		& .ant-btn:last-child {
			margin-left: 10px;
		}
	}
`;
